import { Component, HostBinding } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RenderNotImplementedError } from '../render-flow.model';
import { RenderFlowService } from '../render-flow.service';
import { RENDER_PRICE_USD, RENDER_VIDEO_SPEC_PARTS } from '../render.data';
import { RenderStepBase } from './render-step-base';

// Step 2's purchase half, stub (Figma 28520:21850): the pack on both devices and a pay button.
// An upload on the dev render backend goes to Stripe Checkout instead (RenderBackend.createCheckout
// returns a URL and this page is skipped); Stripe's return (/success, RenderCheckoutReturnGuard)
// lands on /render/confirming/:modelId?session_id=….
// Preview and purchase are one step now, so the way back to the preview is the card's own link.
@Component({
  selector: 'app-render-checkout-step',
  templateUrl: './render-checkout-step.component.html',
})
export class RenderCheckoutStepComponent extends RenderStepBase {
  @HostBinding('class') public readonly hostClass = 'render-step step-checkout';

  public readonly price = RENDER_PRICE_USD;
  public readonly videoSpec = RENDER_VIDEO_SPEC_PARTS;
  public paying = false;
  public error = '';

  constructor(route: ActivatedRoute, router: Router, flow: RenderFlowService) {
    super(route, router, flow);
  }

  public onBack(): void {
    if (this.job && !this.paying) {
      this.flow.cancelCheckout(this.job.modelId);
    }
  }

  public async onPay(): Promise<void> {
    if (!this.job || this.paying) {
      return;
    }
    this.paying = true;
    this.error = '';
    try {
      await this.flow.confirmPayment(this.job.modelId, `stub_${this.job.modelId}`);
    } catch (e) {
      this.error = e instanceof RenderNotImplementedError ? e.message : 'The payment could not be confirmed. Please try again.';
    } finally {
      this.paying = false;
    }
  }
}
